import { StructuredText } from 'react-datocms';
import Sessions from 'react-scale/components/pages/transformx/speaker/sessions';
import SpeakerAvatar from 'react-scale/components/pages/transformx/speakers/speakerAvatar';

import Header, { Title, Socials } from './header';

const Speaker = ({ speaker, sessions }) => (
  <div className="flex flex-col mt-8 md:flex-row">
    <div className="md:w-1/4">
      <div className="md:hidden">
        <Header speaker={speaker} />
      </div>
      <div className="my-4 rounded-lg">
        <SpeakerAvatar avatar={speaker.avatar} />
        <div className="hidden md:block">
          <Socials speaker={speaker} />
        </div>
      </div>
    </div>

    {/* Bio */}
    <div className="mt-8 md:ml-16 md:w-3/4">
      <h5 className="text-3xl leading-relaxed md:hidden">Bio</h5>
      <div className="hidden md:block md:mb-8">
        <h1 className="mb-4 text-5xl leading-none">{speaker.name}</h1>
        <Title positions={speaker.positions} />
      </div>
      <StructuredText data={speaker.bio} className="text-base" />
      <div className="my-16" />
      <Sessions sessions={sessions.filter(({ watchVideoCta }) => watchVideoCta)} />
    </div>
  </div>
);

export default Speaker;
